const ROOT_API = process.env.VUE_APP_ROOT_API
const SSO_URL = process.env.VUE_APP_SSO_IDP_URL
const API_ENDPOINTS = {
  encrypt: 'encrypt',
  decrypt: 'decrypt/',
  list: 'list',
  expire: 'expire/',
  details: 'details/',
  me: 'me',
}

export { ROOT_API, API_ENDPOINTS, SSO_URL }
